import type { Ref } from 'vue'
import type { FeatureIdEnum } from '../../enums/feature-id.enum'
import type { ToolReportTotals } from '../../models'
import type { ToolReportingService } from '../../services'
import { ref, watch } from 'vue'
import { CONTAINER } from '../../config'
import { TYPES } from '../../config/inversify.types'
import { useFilters } from '../use-filters'

export interface ToolingReportStatsComposable {
  stats: Ref<ToolReportTotals>
}

export function useToolingReportStats(tool: FeatureIdEnum): ToolingReportStatsComposable {
  const { selectedDates } = useFilters()
  const stats = ref()

  async function getStats(): Promise<void> {
    const [startDate, endDate] = selectedDates.value
    const service = CONTAINER.get<ToolReportingService>(TYPES.ToolReportingService)
    const response = await service.listTotals({
      tool,
      startDate: new Date(startDate).toISOString(),
      endDate: new Date(endDate).toISOString(),
    })
    stats.value = response
  }

  watch(
    selectedDates,
    () => {
      void getStats()
    },
    { immediate: true },
  )

  return {
    stats,
  }
}
